/* eslint-disable */
import React, { useEffect, useState } from "react";
import styles from "../CandidatePipeline.module.scss";
import { IoClose } from "react-icons/io5";
import { decryptedAdminID, expOptions, sources } from "../../../../utility";

import { TextField, Autocomplete } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchKeySkills,
  selectKeySkills,
} from "../../../../redux-store/slices/candidateKanbanSlice";

const CommonFilterOffcanvas = ({ filters, onApply, onReset, onClose, options = {} }) => {
  const dispatch = useDispatch();
  const loggedId = Number(decryptedAdminID());
  const adminList = JSON.parse(localStorage.getItem("AdminList") || "[]");

  const [form, setForm] = useState({});
  const [expType, setExpType] = useState(null);
  const [isCustomExp, setIsCustomExp] = useState(false);

  const { data: keySkills } = useSelector(selectKeySkills);
  const adminDetails = useSelector((state) => state.adminDetails);

  const isSuperAdmin = adminDetails.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";

  const role = isSuperAdmin ? "superadmin" : isTeamLeader ? "teamleader" : "admin";

  const getDefaultAssignState = () => {
    if (role === "superadmin") return { assign_to: null, onlyMe: false };
    if (role === "teamleader") return { assign_to: loggedId, onlyMe: true };
    return { assign_to: loggedId, onlyMe: true };
  };

  // ─── Key Skills ──────────────────────────────────────────
  const calledRef = React.useRef(false);
  useEffect(() => {
    if (!calledRef.current) {
      dispatch(fetchKeySkills());
      calledRef.current = true;
    }
  }, [dispatch]);

  // ─── Init form — ensure array fields are always [] ───────
  useEffect(() => {
    setForm({
      ...getDefaultAssignState(),
      ...filters,
      job_category:  Array.isArray(filters.job_category)  ? filters.job_category  : [],
      pref_location: Array.isArray(filters.pref_location) ? filters.pref_location : [],
      pref_area:     Array.isArray(filters.pref_area)     ? filters.pref_area     : [],
    });
  }, [filters]);

  const handleChange = (key, val) =>
    setForm((prev) => ({ ...prev, [key]: val === "" ? null : val }));

  const skillOptions = (keySkills || []).map((item) => ({
    label: item.skill,
    value: item.id,
  }));

  // ─── Options from prop ───────────────────────────────────
  const jobOptions      = options.jobCategory  || [];
  const locationOptions = options.prefLocation || [];
  const areaOptions     = options.prefArea     || [];

  // ─── Multi-select helpers ────────────────────────────────
  // Options can be plain strings OR {label, value} objects — handle both
  const resolveLabel   = (opt) => opt?.label ?? opt;
  const resolveSelected = (optList, formArr) =>
    (optList || []).filter((o) => (formArr || []).includes(resolveLabel(o)));

  // ─── Tag render ──────────────────────────────────────────
  const chipStyle = { background: "#e0e0e0", padding: "4px 8px", borderRadius: "16px", fontSize: "12px" };
  const autoSX = {
    width: "100%",
    "& .MuiAutocomplete-inputRoot": {
      flexWrap: "wrap", alignItems: "flex-start", gap: "6px", paddingTop: "6px", paddingBottom: "6px",
    },
  };
  const renderTags = (value, getTagProps) =>
    value.map((option, index) => (
      <span {...getTagProps({ index })} key={resolveLabel(option)} style={chipStyle}>
        {resolveLabel(option)}
      </span>
    ));

  // ─── Merged admin list ───────────────────────────────────
  const mergedAdminList = (() => {
    const exists = adminList.some((a) => a.id === loggedId);
    if (exists) return adminList;
    return [{ id: loggedId, name: "You" }, ...adminList];
  })();

  // ─── Assign options ──────────────────────────────────────
 const assignOptions = (() => {
  const memberOptions = mergedAdminList
    .filter((a) => a.id !== loggedId)
    .map((a) => ({ label: a.name, value: a.id }));

  if (role === "superadmin") {
    return [
      { label: "All", value: "all" },
      { label: "Self", value: "self" },
      ...memberOptions,
    ];
  }

  if (role === "teamleader") {
    return [
      { label: "My Team", value: "team" },
      { label: "Self", value: "self" },
      ...memberOptions,
    ];
  }

  return [];
})();

  // ─── Derive selected assign value ────────────────────────
const assignValueObj = (() => {
  if (role === "superadmin") {
    if (form.assign_to === null && form.onlyMe === false)
      return assignOptions.find((o) => o.value === "all") || null;

    if (Number(form.assign_to) === loggedId && form.onlyMe === true)
      return assignOptions.find((o) => o.value === "self") || null;

    return assignOptions.find(
      (o) => Number(o.value) === Number(form.assign_to)
    ) || null;
  }

  if (role === "teamleader") {
    if (Number(form.assign_to) === loggedId && form.onlyMe === false)
      return assignOptions.find((o) => o.value === "team") || null;

    if (Number(form.assign_to) === loggedId && form.onlyMe === true)
      return assignOptions.find((o) => o.value === "self") || null;

    return assignOptions.find(
      (o) => Number(o.value) === Number(form.assign_to)
    ) || null;
  }

  return null;
})();

  // ─── Handle assign change ────────────────────────────────
  const handleAssignChange = (_, selected) => {
    if (!selected) return;
    const val = selected.value;
if (role === "superadmin") {
  if (val === "all") {
    setForm((f) => ({ ...f, assign_to: null, onlyMe: false }));
  } else if (val === "self") {
    setForm((f) => ({ ...f, assign_to: loggedId, onlyMe: true }));
  } else {
    setForm((f) => ({ ...f, assign_to: Number(val), onlyMe: true }));
  }
  return; // ✅ IMPORTANT
}
    if (role === "teamleader") {
      if (val === "team")      setForm((f) => ({ ...f, assign_to: loggedId,    onlyMe: false }));
      else if (val === "self") setForm((f) => ({ ...f, assign_to: loggedId,    onlyMe: true  }));
      else                     setForm((f) => ({ ...f, assign_to: Number(val), onlyMe: true  }));
      return;
    }
  };
  

  // ─── Experience sync ──────────────────────────────────────
  useEffect(() => {
    if (isCustomExp) return;
    if (form.exp_from == null && form.exp_to == null) { setExpType(null); return; }
    const match = expOptions.find(
      (opt) => opt.min === Number(form.exp_from) && opt.max === Number(form.exp_to),
    );
    if (match) { setExpType(match); }
    else { setExpType(expOptions.find((o) => o.label === "Custom")); setIsCustomExp(true); }
  }, [form.exp_from, form.exp_to]);

  return (
    <div className={styles.offcanvas}>
      {/* HEADER */}
      <div className={styles.offcanvasHeader}>
        <h5>Common Filter</h5>
        <button className={styles.closeBtn} onClick={onClose}><IoClose size={20} /></button>
      </div>

      {/* BODY */}
      <div className={styles.offcanvasBody}>
        <div>

          {/* ASSIGN TO */}
          {(isSuperAdmin || isTeamLeader) && (
            <Autocomplete
              options={assignOptions}
              value={assignValueObj}
              onChange={handleAssignChange}
              getOptionLabel={(opt) => opt?.label || ""}
              isOptionEqualToValue={(o, v) =>
  String(o.value) === String(v.value)
}
              renderInput={(params) => (
                <TextField {...params} label="Assign To" margin="dense" />
              )}
            />
          )}

          <div className={styles.filterGrid}>
            {/* MOBILE */}
            <TextField
              fullWidth
              size="medium"
              label="Mobile Number"
              value={form.mobile_number ?? ""}
              onChange={(e) => {
                let val = e.target.value.replace(/\D/g, "");
                if (val.length <= 10) handleChange("mobile_number", val);
              }}
              margin="dense"
            />

            {/* NAME */}
            <TextField
              fullWidth
              size="medium"
              label="Name"
              value={form.first_name ?? ""}
              onChange={(e) => {
                const val = e.target.value;
                if (/^[a-zA-Z\s]*$/.test(val)) handleChange("first_name", val);
              }}
              margin="dense"
            />
          </div>

          {/* JOB CATEGORY — multi-select → sends [] */}
          <Autocomplete
            multiple
            options={jobOptions}
            value={resolveSelected(jobOptions, form.job_category)}
            onChange={(e, val) =>
              handleChange("job_category", val.map(resolveLabel))
            }
            getOptionLabel={resolveLabel}
            isOptionEqualToValue={(o, v) => resolveLabel(o) === resolveLabel(v)}
            renderTags={renderTags}
            renderInput={(params) => (
              <TextField {...params} label="Job Category" size="medium" margin="dense" />
            )}
            sx={autoSX}
          />

          {/* SOURCE */}
          <Autocomplete
            options={sources}
            value={form.source || null}
            onChange={(e, val) => handleChange("source", val)}
            renderInput={(params) => (
              <TextField {...params} label="Source" size="medium" margin="dense" />
            )}
          />

          {/* SKILL */}
          <Autocomplete
            options={skillOptions}
            value={
              skillOptions.find((opt) => Number(opt.value) === Number(form.skill)) || null
            }
            onChange={(e, selected) =>
              handleChange("skill", selected ? Number(selected.value) : null)
            }
            getOptionLabel={(option) => option.label || ""}
            isOptionEqualToValue={(option, value) =>
              Number(option.value) === Number(value.value)
            }
            renderInput={(params) => (
              <TextField {...params} label="Skill" size="medium" margin="dense" />
            )}
          />

          <div className={styles.filterGrid}>
            {/* LOCATION — multi-select → sends [] */}
            <Autocomplete
              multiple
              options={locationOptions}
              value={resolveSelected(locationOptions, form.pref_location)}
              onChange={(e, val) =>
                handleChange("pref_location", val.map(resolveLabel))
              }
              getOptionLabel={resolveLabel}
              isOptionEqualToValue={(o, v) => resolveLabel(o) === resolveLabel(v)}
              renderTags={renderTags}
              renderInput={(params) => (
                <TextField {...params} label="Preferred Location" size="medium" margin="dense" />
              )}
              sx={autoSX}
            />

            {/* AREA — multi-select → sends [] */}
            <Autocomplete
              multiple
              options={areaOptions}
              value={resolveSelected(areaOptions, form.pref_area)}
              onChange={(e, val) =>
                handleChange("pref_area", val.map(resolveLabel))
              }
              getOptionLabel={resolveLabel}
              isOptionEqualToValue={(o, v) => resolveLabel(o) === resolveLabel(v)}
              renderTags={renderTags}
              renderInput={(params) => (
                <TextField {...params} label="Preferred Area" size="medium" margin="dense" />
              )}
              sx={autoSX}
            />
          </div>

          {/* EXPERIENCE */}
          <Autocomplete
            options={expOptions}
            value={expType}
            onChange={(e, selected) => {
              setExpType(selected);
              if (!selected) return;
              if (selected.label === "Custom") {
                setIsCustomExp(true);
                setForm((p) => ({ ...p, exp_from: null, exp_to: null }));
              } else {
                setIsCustomExp(false);
                setForm((p) => ({ ...p, exp_from: selected.min, exp_to: selected.max }));
              }
            }}
            getOptionLabel={(opt) => opt.label}
            isOptionEqualToValue={(o, v) => o.label === v.label}
            renderInput={(params) => (
              <TextField {...params} label="Experience" size="medium" margin="dense" />
            )}
          />

          {/* CUSTOM EXP */}
          {isCustomExp && (
            <>
              <TextField
                fullWidth size="medium" label="Min Exp"
                value={form.exp_from ?? ""}
                onChange={(e) => {
                  let val = e.target.value.replace(/\D/g, "");
                  if (val.length <= 2) handleChange("exp_from", val);
                }}
                margin="dense"
              />
              <TextField
                fullWidth size="medium" label="Max Exp"
                value={form.exp_to ?? ""}
                onChange={(e) => {
                  let val = e.target.value.replace(/\D/g, "");
                  if (val.length <= 2) handleChange("exp_to", val);
                }}
                margin="dense"
              />
            </>
          )}
        </div>
      </div>

      {/* FOOTER */}
      <div className={styles.offcanvasFooter}>
        <button className={styles.resetBtn} onClick={() => { onReset(); onClose(); }}>
          Reset
        </button>
        <button className={styles.applyBtn} onClick={() => { onApply(form); onClose(); }}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default CommonFilterOffcanvas;